module.exports = __webpack_public_path__ + "img/t4-teal.9e00ae8f.png";